import React, { useState } from "react";
// import {useHistory} from 'react-router-dom';
import { useDispatch } from "react-redux";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { forgotPassword } from "../features/users/auth";

const ColorButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    // fontWeight: 'bold',
  },
}))(Button);

const SecondaryButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    backgroundColor: "#336699",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: " #336699",
    },
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  linkText: {
    fontSize: 16,
    display: "flex",
    alignItems: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#42494E",
    color: "#FFF",
  },
}));

export default function ForgotPassword() {
  const classes = useStyles();
  // const history = useHistory();
  const dispatch = useDispatch();
  // const forgotSuccess = useSelector((state) => state.signin.forgot);
  // const error = useSelector((state) => state.signin.error);
  const error = false; // ~!!! temp
  const [username, setUser] = useState("");

  const submitForgot = (event) => {
    event.preventDefault();

    dispatch(forgotPassword({ username: username }));
  };

  // if (forgotSuccess !== null) {
  //   history.push('/signin');
  // }

  return (
    <Card elevation={4}>
      <Container className={classes.paper} maxWidth="sm">
        <CssBaseline />
        <div>
          <img src="/ps-logo-new.png" style={{ width: "20rem" }} alt="logo" />{" "}
        </div>
        <form className={classes.form} onSubmit={submitForgot}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={(e) => setUser(e.target.value)}
            helperText={error ? error.message : ""}
          />
          <ColorButton type="submit" fullWidth variant="contained">
            Send Reset Password Link
          </ColorButton>
          <Link to="/signin">
            <SecondaryButton type="link" fullWidth variant="contained">
              Return to login
            </SecondaryButton>
          </Link>
        </form>
      </Container>
    </Card>
  );
}
